import { FunctionComponent } from 'react';

import { CardHeader as MuiCardHeader, CardHeaderProps as MuiCardHeaderProps } from '@mui/material';

import { HStack } from '../HStack';

interface ICardHeaderProps extends Omit<MuiCardHeaderProps, 'title' | 'actions' | 'action'> {
    title: React.ReactNode;
    actions?: React.ReactNode;
}
export const CardHeader: FunctionComponent<ICardHeaderProps> = (props: ICardHeaderProps) => {

    const {
        title,
        actions,
        ...cardHeaderBaseProps
    } = props;

    return (
        <MuiCardHeader
            {...cardHeaderBaseProps}
            title={!actions ? title : (
                <HStack columnGap={3} justifyContent='space-between'>
                    {title}

                    {actions && (
                        <HStack columnGap={2} rowGap={1}>
                            {actions}
                        </HStack>
                    )}
                </HStack>
            )}
        />
    );
}